import { RootState } from '../store';
import { StaffState } from './types';

export const selectStaff = (state: RootState): StaffState => state.staff;